const ru = {
  // Page
  pageTitle: 'Vibe Suite — карта AI-навыков',
  pageSubtitle: 'Ваш путь от первого промпта до готового продукта',
  firstTimeClick: 'Первый раз? Нажмите сюда',
  searchPlaceholder: 'Поиск навыков...',
  showLabel: 'Показать',
  filterAll: 'Все',
  filterLearned: 'Изучено',
  filterNotLearned: 'Не изучено',

  // Guide modal
  guideAccent: 'Как это работает',
  guideTitle: 'Ваш AI учит. Эта карта говорит ему чему.',
  guideStep1Title: 'Выберите навык',
  guideStep1Desc:
    'Каждая карточка\u00A0— реальный проект. Нажмите, чтобы увидеть, что вы построите, и получить готовую инструкцию для AI.',
  guideStep2Title: 'Отдайте AI',
  guideStep2Desc:
    'Скопируйте инструкцию и вставьте в Claude, ChatGPT или Cursor. Стройте проект вместе, шаг за шагом.',
  guideStep3Title: 'Отметьте как изученный',
  guideStep3Desc:
    'Закончили? Отметьте. Прогресс-бар и рекомендации обновятся автоматически.',
  guideGotIt: 'Понятно',

  // Why modal
  whyP1:
    'Большинство офисных работников становятся ненужными. Не в следующем году. Прямо сейчас. Каждый день.',
  whyP2:
    'Это не тревожность от новостей\u00A0— это математика. AI заменяет задачи, задачи составляют работу, работа исчезает тихо, пока люди спорят в Twitter, происходит ли это «на самом деле».',
  whyP3:
    'Эта карта навыков\u00A0— ваш шанс остаться востребованным. Научитесь строить с AI\u00A0— а не конкурировать с ним\u00A0— чтобы в 30 и 40 лет вы всё ещё могли выбирать, чем заниматься.',

  // ProgressHeader
  milestoneObserver: 'Наблюдатель',
  milestoneExplorer: 'Исследователь',
  milestoneMaster: 'Мастер',
  milestoneSingularity: 'Сингулярность',
  reached: 'Достигнуто!',
  skillSingular: 'навык',
  skillPlural: 'навыков',
  toMilestone: 'до',
  myProgress: 'Мой прогресс',
  progressBody1:
    'Скопируйте свой профиль обучения и вставьте в любой AI-ассистент, которым пользуетесь.',
  progressBody2:
    'Расскажите, что хотите построить\u00A0— AI увидит, какие навыки у вас есть, а каких нет, и предложит подход, который использует ваши сильные стороны и закроет пробелы.',
  copyStateLine1:
    'Вот мой профиль навыков. Каждый навык отмечен как ИЗУЧЕНО или НЕ ИЗУЧЕНО.',
  copyStateLine2:
    'Когда я опишу, что хочу построить, используй этот профиль, чтобы:',
  copyStateLine3:
    '1. Предложить архитектуру и стек, которые используют навыки, которые я уже знаю.',
  copyStateLine4:
    '2. Определить, какие навыки я ещё не изучил, но они были бы полезны для проекта, и предложить изучить их по ходу.',
  copyStateLine5:
    '3. Дать варианты\u00A0— один путь в зоне комфорта, один с вызовом, и один сбалансированный.',
  progressPrefix: 'Прогресс:',
  skillsWord: 'навыков',
  learned: 'ИЗУЧЕНО',
  notLearned: 'НЕ ИЗУЧЕНО',
  copyStateEnd: 'Итак, вот что я хочу построить:',
  copied: 'Скопировано',
  copyMyLearningState: 'Скопировать профиль',
  close: 'Закрыть',
  toTheGlory: 'К   С Л А В Е',

  // CategoryNav
  categoriesTitle: 'Категории',
  whatToLearnNext: 'Что учить дальше?',
  personalizedForYou: 'Подобрано для вас',
  allCategories: 'Все категории',
  whyDoINeedThis: 'Зачем мне это?',

  // SkillDetailPanel
  difficultyBeginner: 'Начальный',
  difficultyIntermediate: 'Средний',
  difficultyAdvanced: 'Продвинутый',
  whatYoullBuild: 'Что вы построите',
  tools: 'Инструменты',
  prerequisites: 'Предварительные навыки',
  howToLearnThis: 'Как изучить',
  hideGuide: 'Скрыть гайд',
  firstTimeReadThis: 'Первый раз? Прочтите',
  detailGuideHeading: 'Каждый навык\u00A0— реальный проект с AI:',
  detailGuideStep1Bold: 'Скопируйте инструкцию',
  detailGuideStep1Rest:
    'ниже и вставьте в AI-ассистент (Claude, ChatGPT, Cursor и т.д.)',
  detailGuideStep2Bold: 'Следуйте за AI',
  detailGuideStep2Rest:
    'который проведёт вас через сборку проекта шаг за шагом',
  detailGuideStep3Bold: 'Отметьте как изученный',
  detailGuideStep3Rest:
    'когда закончите. Никаких тестов, никаких оценок\u00A0— вы построили, вы научились.',
  detailGuideTip:
    'Вот и всё. Никаких видео. Никаких курсов. Вы учитесь, строя реальные вещи.',
  copiedExcl: 'Скопировано!',
  copyInstruction: 'Скопировать',
  unmarkAsLearned: 'Снять отметку',
  markAsLearned: 'Отметить как изученный',

  // Knowledge Gaps
  knowledgeGaps: 'Ваши пробелы',
  knowledgeGapsTitle: 'AI SaaS платформа — полный путь разработки',
  knowledgeGapsSubtitle: 'Ваши знания на карте реального проекта',
  stageTooling: 'Настройка инструментов',
  stagePrototype: 'Прототип',
  stageBackend: 'Основа бэкенда',
  stageAiCore: 'AI-ядро',
  stageFrontendPolish: 'Финиш фронтенда',
  stageInfrastructure: 'Инфраструктура',
  stageMonetization: 'Монетизация и рост',
  stageIntegrations: 'Интеграции',
  stageSecurity: 'Безопасность',
  stageScale: 'Масштаб и оптимизация',

  // RecommendationModal
  whatToLearnNextTitle: 'Что изучить дальше',

  // Recommendation reasons
  reasonUnlocks: 'Открывает',
  reasonNewSkill: 'новый навык',
  reasonNewSkills: 'новых навыков',
  reasonQuickWin: 'Быстрая победа',
  reasonMatchesLevel: 'Подходит под ваш уровень',
  reasonAllPrereqsDone: 'Все предварительные навыки изучены',
  reasonGoodNextStep: 'Хороший следующий шаг',
};

export default ru;
